import { render, staticRenderFns } from "./educationMyTeam.vue?vue&type=template&id=555ece5f&scoped=true"
import script from "./educationMyTeam.vue?vue&type=script&lang=js"
export * from "./educationMyTeam.vue?vue&type=script&lang=js"
import style0 from "./educationMyTeam.vue?vue&type=style&index=0&id=555ece5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ece5f",
  null
  
)

export default component.exports